/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { niveauActions } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_pres_041: Question = {
  id: 'pres-041-plan-action-eee',
  oldId: '55',
  title: 'Développement d’un plan d’action pour lutter contre les EEE',
  number: '4.3',
  description: [''],
  type: QuestionType.ACTIVITY,
  frequency: 1,
  idEM: 5,
  slots: [
    {
      type: SlotTypes.NIVEAU,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: false,
      optional: false,
      scoringFct: (data: string[]) => parseFloat(data[0]),
      score: '0',
      maxScore: 1,
      help: niveauActions,
      unit: SlotUnit.OPTIONS,
    },
  ],
};

const question_pres_041__v3: Question = {
  ...question_pres_041,
  title: 'Mise en oeuvre d’un plan d’action pour lutter contre les EEE',
};

export const question_pres_041_v2: Question = question_pres_041;
export const question_pres_041_v3: Question = question_pres_041__v3;
